<template>
  <section class="pt-4 mb-4">
    <div v-if="descriptionSheetDetails && !isLoading">
      <h1 class="h3 mb-4">
        {{ $t("employee-support-business") }}
      </h1>
      <b-row>
        <b-col>
          <div class="mb-3">
            <b-button
              variant="outline-primary"
              @click="backtoList"
            >
              {{ $t("support-business-return") }}
            </b-button>
          </div>
          <div class="mb-2 d-flex justify-content-start py-1">
            <div class="pr-2">
              <em :class="getDescriptionSheetIcon(descriptionSheetDetails)" width="24" height="24" />
            </div>
            <div>
              <div class="type">
                <strong>{{ descriptionSheetDetails.title }}</strong>
              </div>
              <div class="path">
                <em>{{ getCategoryPath(descriptionSheetDetails) }}</em>
              </div>
            </div>
          </div>
          <div
            class="mb-3 content px-2"
            v-html="descriptionSheetDetails.description"
          ></div>
          <div class="related">
            <div class="type mb-2">
              <strong>{{ $t("support-business-suggestion") }} :</strong>
            </div>
            <description-sheet
              :isSuggestionSheet="true"
              :descriptionSheets="suggestionDescriptionSheets"
            />
          </div>
        </b-col>
      </b-row>
    </div>
    <div v-if="isLoading" class="text-center">
      <b-spinner variant="primary" />
    </div>
  </section>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import descriptionSheet from "@/mixins/descriptionSheet";

const DescriptionSheet = () =>
  import("@/components/DescriptionSheet/DescriptionSheet.vue");

export default {
  components: {
    DescriptionSheet,
  },
  mixins: [descriptionSheet],
  computed: {
    ...mapGetters(["isLoading"]),
    ...mapGetters("descriptionSheets", {
      descriptionSheetDetails: "descriptionSheetDetails",
    }),
    ...mapGetters("suggestionDescriptionSheets", {
      suggestionDescriptionSheets: "suggestionDescriptionSheets",
    }),
  },
  watch: {
    $route(value) {
      const id = value.params.id;
      this.init(id);
    },
  },
  created() {
    const id = this.$route.params.id;
    this.init(id);
  },
  methods: {
    ...mapActions("descriptionSheets", {
      getDescriptionSheetById: "getDescriptionSheetById",
      getDescriptionSheets: "refresh",
    }),
    ...mapActions("suggestionDescriptionSheets", {
      getSuggestionDescriptionSheets: "getSuggestionDescriptionSheets",
    }),
    init(id) {
      if (id) {
        this.getDescriptionSheetById(id);
        this.getSuggestionDescriptionSheets(id);
      }
    },
    backtoList() {
      this.$router.go(-1);
    },
  },
};
</script>

<style lang="scss">
.content {
  img {
    max-width: 100%;
    height: auto !important;
  }
  iframe {
    max-width: 100%;
  }
}
</style>
<style lang="scss" scoped>
.content {
  border: 1px solid rgba(0, 0, 0, 0.125);
  background: #ffffff;
  overflow: auto;
  white-space: pre-line;
  overflow-wrap: break-word;
  word-break: break-word;
}
.box {
  cursor: pointer;
  width: 100%;
  min-width: 350px;
  max-width: 350px;
  border: 1px solid rgba(0, 0, 0, 0.125);
  background: #ffffff;
}
.type {
  font-size: 1rem;
  font-weight: 500;
}
.path {
  color: gray;
  white-space: break-spaces;
  overflow-wrap: break-word;
  word-break: break-word;
}
</style>